// DIFF vs V1 : module local remplaçant ChartModule ('primeng/chart' v8) — voir ui-chart.component.ts.
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { UiChartComponent } from './ui-chart.component';

@NgModule({
  imports: [CommonModule],
  declarations: [UiChartComponent],
  exports: [UiChartComponent]
})
export class UiChartModule { }
